import Component from '../core/Component'

export const STATUS = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible'
}

export const defaults = {
    static: false
}

export default class Layer extends Component {

    constructor(element) {
        super(element, defaults)

        this.origin = null
        this.arrowOnly = false

        this.handleOuterClick = ::this.handleOuterClick
        this.handleKeydown = ::this.handleKeydown
        this.handleResize = ::this.handleResize
        this.handleScroll = ::this.handleScroll

        this.options.static = this.element.dataset.componentStatic

        this.ref = {
            arrow: null,
            content: null
        }
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.stopPropagation()
    }

    handleOuterClick() {
        this.close()
    }

    handleKeydown(event) {
        if (event.keyCode === 27) {
            this.close()
        }
    }

    handleResize() {
        this.render()
        this.renderContent()
        this.renderArrow()
    }

    handleScroll() {
        this.render()
    }

    destroy() {
        this.close()
    }

    open(origin, arrowOnly = false) {
        if (this.is(STATUS.ACTIVE)) {
            return;
        }

        this.origin = origin
        this.arrowOnly = arrowOnly

        this.element.classList.add(STATUS.VISIBLE)
        this.element.offsetWidth

        if (this.origin && !this.arrowOnly) {
            this.render()
            this.renderContent()
            this.renderArrow()
        }

        if (this.origin && this.arrowOnly) {
            this.renderArrow()
        }

        this.element.classList.add(STATUS.ACTIVE)

        setTimeout(() => {
            document.body.addEventListener('click', this.handleOuterClick)
            document.body.addEventListener('keydown', this.handleKeydown)
            window.addEventListener('resize', this.handleResize)
            window.addEventListener('scroll', this.handleScroll, {
                passive: true
            })
        }, 0)
    }

    close() {
        this.element.classList.remove(STATUS.ACTIVE)
        this.element.classList.remove(STATUS.VISIBLE)
        document.body.removeEventListener('click', this.handleOuterClick)
        document.body.removeEventListener('keydown', this.handleKeydown)
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('scroll', this.handleScroll)
        this.origin = null
        this.arrowOnly = false
    }

    render() {
        if (!this.origin || this.options.static) {
            return
        }

        const box = this.origin.getBoundingClientRect()
        this.element.style.top = `${box.top + box.height}px`
        this.element.style.left = `${box.left + box.width/2}px`
    }

    renderArrow() {
        if (!this.ref.arrow) {
            return
        }

        const originBox = this.origin.getBoundingClientRect()
        const box = (this.ref.content ? this.ref.content : this.element).getBoundingClientRect()
        const arrowBox = this.ref.arrow.getBoundingClientRect()

        this.ref.arrow.style.left = `${originBox.left + originBox.width/2 - box.left + (this.ref.content ? 10 : 0) - arrowBox.width/2}px`
    }

    renderContent() {
        if (!this.ref.content) {
            return
        }

        this.ref.content.removeAttribute('style')

        const contentBox = this.ref.content.getBoundingClientRect()
        const offset = Math.abs(contentBox.left) + 10

        if (contentBox.left < 10) {
            this.ref.content.style.left = `${offset}px`
        } else if (contentBox.left + contentBox.width > window.innerWidth) {
            this.ref.content.style.left = `${window.innerWidth - contentBox.left - contentBox.width - 10}px`
        } else {
            this.ref.content.removeAttribute('style')
        }
    }

}